import { render, staticRenderFns } from "./zr.vue?vue&type=template&id=366ddd0b&scoped=true"
import script from "./zr.vue?vue&type=script&lang=js"
export * from "./zr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ddd0b",
  null
  
)

export default component.exports